// Tienda: carrito guardado en el navegador + cálculo de envío/IVA.
// Las reglas (costo de envío, mínimo para envío gratis, IVA) vienen del API
// en GET /orders/delivery-options - aquí no hay montos escritos.

const CART_KEY = 'storeCart';

// El carrito sobrevive a recargar la página y a ir a iniciar sesión.
// { [productId]: quantity }
export const loadCart = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(CART_KEY));
    return saved && typeof saved === 'object' ? saved : {};
  } catch {
    return {};
  }
};

export const saveCart = (cart) => {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
  } catch {
    // almacenamiento bloqueado (modo privado, etc.) - el carrito vive solo en memoria
  }
};

export const clearCart = () => saveCart({});

export const formatMXN = (amount) =>
  `$${amount.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const round = (n) => Math.round(n * 100) / 100;

// Mismo cálculo que calculateOrderCharges en macarios-api/config/store.js -
// si cambias uno, cambia el otro. `options` es la respuesta de delivery-options.
// Sin `options` (aún no carga / no ha iniciado sesión) solo se conoce el subtotal.
export const calculateOrderCharges = (subtotal, options) => {
  if (!options) {
    return { subtotal: round(subtotal), shippingCost: 0, iva: 0, total: round(subtotal) };
  }
  const { shippingCost: baseShipping, freeShippingMin, ivaRate } = options;
  // El IVA se cobra siempre; con reservación solo se quita el envío
  const freeShipping = Boolean(options.deliveryBooking) || (freeShippingMin !== null && subtotal >= freeShippingMin);
  const shippingCost = freeShipping ? 0 : baseShipping;
  const iva = round((subtotal + shippingCost) * ivaRate);
  return {
    subtotal: round(subtotal),
    shippingCost,
    iva,
    total: round(subtotal + shippingCost + iva),
  };
};

// Textos del producto en el idioma de la página. name/description son el
// español; nameEn/descriptionEn el inglés (opcional, cae al español).
const isEnglish = (lang) => typeof lang === 'string' && lang.startsWith('en');
export const productName = (product, lang) => (isEnglish(lang) && product.nameEn) || product.name;
export const productDescription = (product, lang) =>
  (isEnglish(lang) && product.descriptionEn) || product.description;
